<template>
  <div class="page-view" :class="{ 'page-view--fill': fill }">
    <DrawingPad v-if="isDrawing" :model-value="strokes" read-only />
    <p v-else class="page-view__word" :class="{ 'page-view__word--blank': blank }">
      {{ blank ? '(left blank)' : page.content }}
    </p>
    <p v-if="showAuthor" class="page-view__by">{{ byline }}</p>
  </div>
</template>

<script>
import DrawingPad from './DrawingPad.vue';
import { STEP_KINDS } from '@/engine/rounds';
import { isBlankPage } from '@/engine/game';

// One page of a book: a word, a guess, or a drawing. Used both as the prompt
// you're reacting to and as a page in the reveal.
export default {
  name: 'PageView',
  components: { DrawingPad },
  props: {
    page: { type: Object, default: null },
    showAuthor: { type: Boolean, default: false },
    // Take all the room the parent gives, rather than a fixed cap. Used on
    // the guess step, where the drawing is the only thing worth looking at.
    // Off in the reveal, which is a scrolling column of pages.
    fill: { type: Boolean, default: false },
  },
  computed: {
    isDrawing() { return this.page?.kind === STEP_KINDS.DRAW; },
    strokes() { return Array.isArray(this.page?.content) ? this.page.content : []; },
    blank() { return isBlankPage(this.page); },
    byline() {
      if (!this.page?.byName) return '';
      const verb = { word: 'started with', draw: 'drew', guess: 'guessed' }[this.page.kind] || 'wrote';
      return `${this.page.byName} ${verb}`;
    },
  },
};
</script>
